export default {
    setTransactionFilterFieldsMutation(state, payload)
    {
        state.transactionFilter.fields.transactionNumber = payload.transaction_number;
        state.transactionFilter.fields.transactionCreatedAt = payload.transaction_created_at;
        state.transactionFilter.fields.transactionAmount = payload.transaction_amount;
        state.transactionFilter.fields.transactionType = payload.transaction_type;
        state.transactionFilter.fields.transactionArticle = payload.transaction_article;
        state.transactionFilter.fields.transactionStatus = payload.transaction_status;
        state.transactionFilter.fields.transactionCompanyId = payload.transaction_company_id;
        state.transactionFilter.fields.filterStartDate = payload.filter_start_date;
        state.transactionFilter.fields.filterEndDate = payload.filter_end_date;
        state.transactionFilter.main_filter = payload.main_filter;
    },
    setTransactionList(state, payload)
    {
        state.transactionList = payload;
    },
    setTransactionListCount(state, payload) {
        state.transactionListCount = payload;
    },
    setSupplementAmount(state, payload) {
        state.supplement_amount = payload;
    },
    setInvoiceId(state, payload) {
        state.invoice_id = payload;
    },
    setModalPaymentQrCodeFormOpen(state, payload) {
        state.modalPaymentQrCodeFormOpen = payload;
    },
}
